var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMySchools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.897 23.745h.002l7.666-.028v16.24h-7.668a.187.187 0 0 1-.189-.19V23.934c0-.089.095-.188.19-.188zm20.668 16.211v-16.24h7.583c.106 0 .189.083.189.19v15.862c0 .094-.1.188-.189.188h-7.583z",
    fill: "#D9D9D9",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.48 30.502h-3.39a.187.187 0 0 1-.188-.189v-3.389c0-.089.094-.189.189-.189h3.389c.023 0 .073.015.123.066.05.05.066.1.066.123v3.418c0 .019-.012.058-.057.1a.21.21 0 0 1-.132.06zM25.48 36.91h-3.39a.187.187 0 0 1-.188-.19v-3.417c0-.106.083-.19.189-.19h3.389c.089 0 .189.095.189.19v3.389c0 .134-.112.217-.19.217zM45.898 30.502h-3.39a.187.187 0 0 1-.188-.189v-3.389c0-.089.094-.189.189-.189h3.389c.094 0 .189.1.189.19v3.417c0 .065-.071.16-.19.16zM45.898 36.91h-3.39a.187.187 0 0 1-.188-.19v-3.417c0-.106.083-.19.189-.19h3.389c.106 0 .189.084.189.19v3.389c0 .146-.095.217-.19.217z",
    fill: "#E8E8E8",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.022 14.44a.187.187 0 0 1-.189-.19V8.67c0-.106.083-.189.19-.189.105 0 .188.083.188.189v5.61c0 .066-.07.16-.189.16z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.249 11.915v.017l.001.016a.13.13 0 0 1-.035.106.173.173 0 0 1-.127.05h-6.066a.187.187 0 0 1-.189-.188V8.668c0-.106.083-.189.19-.189h6.037c.106 0 .189.083.189.189v3.246zM33.942 14.065l.002-.001a.149.149 0 0 1 .182 0l.002.001 6.407 4.215.012.007c.031.019.07.076.07.15V39.73a.397.397 0 0 1-.09.175c-.04.04-.073.05-.099.05H27.642a.187.187 0 0 1-.19-.189v-21.33c0-.046.018-.1.097-.166l6.393-4.206z",
    fill: "#8B8B8B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.682 42.833H17.419a.187.187 0 0 1-.19-.19v-2.876c0-.106.084-.189.19-.189h33.263c.106 0 .189.083.189.19v2.876a.187.187 0 0 1-.19.189z",
    fill: "#8B8B8B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.325 39.671h-6.607a.187.187 0 0 1-.19-.189v-10.65c0-.107.084-.19.19-.19h6.607c.106 0 .189.083.189.19V39.49c-.02.116-.104.181-.19.181z",
    fill: "#EFEFF0",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.022 39.671a.187.187 0 0 1-.189-.189v-10.65c0-.107.083-.19.19-.19.105 0 .188.083.188.19V39.51c0 .066-.07.16-.189.16z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.597 21.238c0-1.48 1.175-2.684 2.642-2.684a2.696 2.696 0 0 1 2.685 2.684 2.696 2.696 0 0 1-2.685 2.685c-1.428 0-2.642-1.208-2.642-2.685z",
    fill: "#DFE1E7",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.772 43.432h.002l7.666-.027v16.239H6.772a.187.187 0 0 1-.189-.19V43.622c0-.09.095-.19.19-.19zM27.44 59.644v-16.24h7.583c.106 0 .189.082.189.188v15.863c0 .095-.1.189-.189.189H27.44z",
    fill: "#D9D9D9",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.355 50.19h-3.39a.187.187 0 0 1-.188-.19v-3.388c0-.09.094-.19.189-.19h3.389c.023 0 .073.015.123.066.05.05.066.1.066.124v3.417c0 .02-.011.059-.057.1a.21.21 0 0 1-.132.06zM12.355 56.596h-3.39a.187.187 0 0 1-.188-.188V52.99c0-.106.083-.189.189-.189h3.389c.089 0 .189.094.189.19v3.388c0 .135-.112.218-.19.218zM32.775 50.19h-3.39a.187.187 0 0 1-.188-.19v-3.388c0-.09.094-.19.189-.19h3.389c.094 0 .189.1.189.19v3.417c0 .066-.071.16-.19.16zM32.775 56.596h-3.39a.187.187 0 0 1-.188-.188V52.99c0-.106.083-.189.189-.189h3.389c.106 0 .189.083.189.19v3.388c0 .146-.095.218-.19.218z",
    fill: "#E8E8E8",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.897 34.127a.187.187 0 0 1-.189-.189v-5.582c0-.106.083-.189.19-.189.105 0 .188.083.188.19v5.61c0 .065-.07.16-.189.16z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.124 31.603v.016l.001.016a.13.13 0 0 1-.035.107.173.173 0 0 1-.127.05h-6.066a.187.187 0 0 1-.189-.19v-3.246c0-.106.083-.189.19-.189h6.037c.106 0 .189.083.189.19v3.246zM20.82 33.752c.063-.042.12-.042.183 0h.002l6.407 4.215.012.008c.031.018.07.075.07.15v21.294a.398.398 0 0 1-.09.174c-.04.04-.073.05-.099.05H14.518a.187.187 0 0 1-.189-.188v-21.33c0-.047.018-.1.096-.167l6.394-4.206z",
    fill: "#8B8B8B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.559 62.52H4.296a.187.187 0 0 1-.19-.19v-2.875c0-.106.084-.19.19-.19h33.263c.106 0 .189.084.189.19v2.876a.187.187 0 0 1-.19.189z",
    fill: "#8B8B8B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.202 59.359h-6.607a.187.187 0 0 1-.19-.19V48.52c0-.106.084-.19.19-.19h6.607c.106 0 .189.084.189.19v10.658c-.02.116-.104.182-.19.182z",
    fill: "#EFEFF0",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.897 59.359a.187.187 0 0 1-.189-.19V48.52c0-.106.083-.19.19-.19.105 0 .188.084.188.19v10.68c0 .065-.07.16-.189.16z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.394 41.044c0-1.48 1.175-2.684 2.642-2.684a2.696 2.696 0 0 1 2.685 2.684 2.696 2.696 0 0 1-2.685 2.685c-1.428 0-2.642-1.208-2.642-2.685z",
    fill: "#DFE1E7",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.21 43.432h.001l7.667-.027v16.239H35.21a.187.187 0 0 1-.19-.19V43.622c0-.09.095-.19.19-.19zm20.668 16.212v-16.24h7.583c.105 0 .189.082.189.188v15.863c0 .095-.1.189-.19.189h-7.582z",
    fill: "#D9D9D9",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.792 50.19h-3.389a.187.187 0 0 1-.189-.19v-3.388c0-.09.095-.19.19-.19h3.388c.023 0 .073.015.124.066.05.05.065.1.065.124v3.417c0 .02-.011.059-.056.1a.21.21 0 0 1-.133.06zM40.792 56.596h-3.389a.187.187 0 0 1-.189-.188V52.99c0-.106.083-.189.19-.189h3.388c.09 0 .19.094.19.19v3.388c0 .135-.112.218-.19.218zM61.21 50.19h-3.389a.187.187 0 0 1-.189-.19v-3.388c0-.09.095-.19.19-.19h3.388c.095 0 .19.1.19.19v3.417c0 .066-.072.16-.19.16zM61.21 56.596h-3.389a.187.187 0 0 1-.189-.188V52.99c0-.106.083-.189.19-.189h3.388c.106 0 .19.083.19.19v3.388c0 .146-.095.218-.19.218z",
    fill: "#E8E8E8",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.335 34.127a.187.187 0 0 1-.19-.189v-5.582c0-.106.084-.189.19-.189s.189.083.189.19v5.61c0 .065-.071.16-.19.16z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.561 31.603v.016l.002.016a.13.13 0 0 1-.036.107.173.173 0 0 1-.126.05h-6.066a.187.187 0 0 1-.19-.19v-3.246c0-.106.084-.189.19-.189h6.037c.106 0 .19.083.19.19v3.246zM49.255 33.753l.001-.002a.149.149 0 0 1 .182 0l.002.002 6.408 4.214.011.008c.032.018.07.075.07.15v21.294a.397.397 0 0 1-.09.174c-.04.04-.072.05-.098.05H42.954a.187.187 0 0 1-.189-.188v-21.33c0-.047.018-.1.096-.167l6.394-4.205z",
    fill: "#8B8B8B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.994 62.52H32.731a.187.187 0 0 1-.189-.189v-2.876c0-.106.083-.19.19-.19h33.262c.106 0 .19.084.19.19v2.876a.187.187 0 0 1-.19.19z",
    fill: "#8B8B8B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.637 59.359H46.03a.187.187 0 0 1-.189-.19V48.52c0-.106.083-.19.19-.19h6.606c.106 0 .19.084.19.19v10.658c-.02.116-.105.182-.19.182z",
    fill: "#EFEFF0",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.335 59.359a.187.187 0 0 1-.19-.19V48.52c0-.106.084-.19.19-.19s.189.084.189.19v10.68c0 .065-.071.16-.19.16z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.647
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.001 41.044c0-1.48 1.175-2.684 2.643-2.684a2.696 2.696 0 0 1 2.684 2.684 2.696 2.696 0 0 1-2.684 2.685c-1.429 0-2.643-1.208-2.643-2.685z",
    fill: "#DFE1E7",
    stroke: "#383838",
    strokeWidth: 0.647
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySchools);
export default __webpack_public_path__ + "static/media/my_schools.5a2307d54ccb4e8939a2c38bb5a5023a.svg";
export { ForwardRef as ReactComponent };